import type { ThemeOptions } from '@mui/material'

import type { ReadonlyRecord } from '../../../utils'

type ShadowSize = 'XS' | 'SM' | 'MD' | 'LG' | 'XL' | '2XL' | '3XL'

const shadowsMap: ReadonlyRecord<ShadowSize, string> = {
    XS: '0 1px 2px 0 rgba(10, 13, 18, 0.05)',
    SM: '0 1px 3px 0 rgba(10, 13, 18, 0.10), 0 1px 2px 0 rgba(10, 13, 18, 0.06)',
    MD: '0 4px 8px -2px rgba(10, 13, 18, 0.10), 0 2px 4px -2px rgba(10, 13, 18, 0.06)',
    LG: '0 12px 16px -4px rgba(10, 13, 18, 0.08), 0 4px 6px -2px rgba(10, 13, 18, 0.03)',
    XL: '0 20px 24px -4px rgba(10, 13, 18, 0.08), 0 8px 8px -4px rgba(10, 13, 18, 0.03)',
    '2XL': '0 24px 48px -12px rgba(10, 13, 18, 0.18)',
    '3XL': '0 32px 64px -12px rgba(10, 13, 18, 0.14)',
}

/** Cast to the left, by a panel docked to the right edge */
export const RIGHT_PANEL_SHADOW = '-1px 0 1px 0 rgba(10, 13, 18, 0.03), -3px 0 3px 0 rgba(10, 13, 18, 0.03), -6px 0 3px 0 rgba(10, 13, 18, 0.02)'

export const shadows = [
    'none',
    shadowsMap.XS,
    shadowsMap.SM,
    shadowsMap.MD,
    shadowsMap.LG,
    shadowsMap.XL,
    shadowsMap['2XL'],
    shadowsMap['3XL'],
    /**
     * MUI requires exactly 25 elevations when defining shadows.
     * Our design system has 7 only, so any elevation above 7 is the same as 3XL.
     */
    ...Array<string>(17).fill(shadowsMap['3XL']),
] as ThemeOptions['shadows']
